import { Box } from '@zillow/constellation';
import { Input, Flex, FormField } from '@zillow/constellation';
import React from 'react';
import {
  IEscrowWireDisbursementsData,
  prettyWireDisbursementsCategories,
} from 'types/order/escrow/IEscrowWireDisbursementsData';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';

interface IVoidWireDetailsProps {
  wireDisbursement: IWireDisbursementFormData | IEscrowWireDisbursementsData;
}

export const VoidWireDetails: React.FC<IVoidWireDetailsProps> = ({ wireDisbursement }) => {
  return (
    <Flex display={'flex'} flexDirection={'column'} gap={1}>
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <Box sx={{ flexGrow: '1' }}>
          <FormField
            label="Amount"
            control={<Input value={currencyDisplay(wireDisbursement.amountCents, true)} disabled />}
          />
        </Box>
        {wireDisbursement.category && (
          <Box sx={{ flexGrow: '1' }}>
            <FormField
              label="Category"
              control={
                <Input
                  value={prettyWireDisbursementsCategories[wireDisbursement.category] ?? wireDisbursement.category}
                  disabled
                />
              }
            />
          </Box>
        )}
      </Flex>
      <FormField label={'Name'} control={<Input value={wireDisbursement.beneficiary ?? ''} disabled />} />
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <Box sx={{ flexGrow: '1' }}>
          <FormField label={'Routing ABA'} control={<Input value={wireDisbursement.routingNumber ?? ''} disabled />} />
        </Box>
        <Box sx={{ flexGrow: '1' }}>
          <FormField
            label={'Account Number'}
            control={<Input value={wireDisbursement.accountNumber ?? ''} disabled />}
          />
        </Box>
      </Flex>
      <FormField label="Memo" control={<Input value={wireDisbursement.memo ?? ''} disabled />} />
    </Flex>
  );
};
